import React from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "../../asset/Breadcrumb/Breadcrumb.module.scss";

// fallback image
import defaultBanner from "../../asset/homefour/about.jpg";

const Breadcrumb = ({ currentPage, bannerImage }) => {
  const location = useLocation();

  const getPathSegments = () => {
    const segments = [{ name: "Home", path: "/" }];

    if (location.pathname !== "/") {
      segments.push({ name: currentPage, path: location.pathname });
    }

    return segments;
  };

  const pathSegments = getPathSegments();

  return (
    <div className={styles.breadcrumbBanner}>
      <img
        src={bannerImage || defaultBanner}
        alt={currentPage}
        className={styles.bannerImage}
      />

      <div className={styles.breadcrumbOverlay}>
        <div className={styles.breadcrumbContent}>
          <h1 className={styles.pageTitle}>{currentPage}</h1>

          <nav className={styles.breadcrumbNav}>
            {pathSegments.map((segment, index) => (
              <React.Fragment key={segment.path}>
                <Link
                  to={segment.path}
                  className={`${styles.breadcrumbLink} ${
                    location.pathname === segment.path ? styles.active : ""
                  }`}
                >
                  {segment.name}
                </Link>

                {index < pathSegments.length - 1 && (
                  <span className={styles.separator}>/</span>
                )}
              </React.Fragment>
            ))}
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
